<template>
  <div>
    <section>
      <b-container>
        <b-row class="mt-5">
          <b-col md="12" sm="12" lg="12" xs="12" xl="4">
            <h1 class="text-center">{{ selectedSoleProprietorship.name }}</h1>
          </b-col>
          <b-col xs="12" class="text-left offer-text text-gray-04">
            Gratulálunk! {{ totalCount }} testre szabott lehetőséget találtunk, amellyel egyéni vállalkozását
            fejlesztheti.
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col md="12" sm="12" lg="12" xs="12" xl="4">
            <div
              class="d-flex justify-content-center mx-auto rounded-circle 
              bg-color-green text-white circle-box circle-box"
            >
              <div class="align-self-center">
                <transition name="fade">
                  <div v-if="showAnimatedElements && selectedSoleProprietorship">{{ totalCount }}</div>
                </transition>
              </div>
            </div>
          </b-col>
          <b-col md="12" sm="12" lg="12" xs="12" xl="8">
            <b-row class="mt-3" id="offer-list">
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <transition name="slide-fade" v-for="(dbOffer, index) in dbOffers" :key="index">
                  <div
                    class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left offer-badge-holder cursor-pointer"
                    v-if="showAnimatedElements && $store.getters[dbOffer.storeName]"
                    @click="nextPage()"
                  >
                    <div
                      class="d-flex justify-content-center rounded-circle bg-color-green text-white circle-mini-box float-left mr-3"
                    >
                      <div class="align-self-center">
                        {{ $store.getters[dbOffer.storeName] }}
                      </div>
                    </div>
                    {{ dbOffer.name }}
                  </div>
                </transition>
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <div
                  class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left cursor-pointer offer-badge-holder"
                  @click="nextPage()"
                  v-for="(offer, index) in constantCompanyOffers"
                  :key="index"
                >
                  <component :is="offer.componentName" class="offer-badge-svg"></component>
                  {{ offer.name }}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <ConsultantOpportunities class="mt-4 mb-5" />
      </b-container>
      <b-container>
        <login-banner :routeparam="{ soleProprietorshipId: this.$route.query.soleProprietorshipId }" />
        <p class="text-gray-04">
          A vali.hu-n megjelenő valamennyi információ, adat, feltétel, meghatározás vagy leírás kizárólag <br />
          tájékoztatásul szolgál.
        </p>
      </b-container>
    </section>
  </div>
</template>

<script>
import SmeClassificationInformation from '@/components/SmeClassificationInformation.vue'
import { mapGetters } from 'vuex'
import queryString from 'query-string'
import LoginBanner from '../components/LoginBanner.vue'
import CertifiedExpertsSvg from '../components/svg/CompanyOffers/CertifiedExperts'
import ModernFactoriesSvg from '../components/svg/CompanyOffers/ModernFactories'
import SchoolSvg from '../components/svg/CompanyOffers/School'
import ConsultancySvg from '../components/svg/CompanyOffers/Consultancy'
import constantCompanyOffers from '../mixins/constantCompanyOffers'
import ConsultantOpportunities from './Opportunities/ConsultantOpportunities.vue'

export default {
  name: 'PublicSoleProprietorshipOffers',
  mixins: [constantCompanyOffers],
  components: {
    LoginBanner,
    CertifiedExpertsSvg,
    ModernFactoriesSvg,
    ConsultantOpportunities,
    SchoolSvg,
    ConsultancySvg,
    SmeClassificationInformation
  },
  data() {
    return {
      selectedCompanyId: '',
      showAnimatedElements: false,
      dbOffers: [
        {
          storeName: 'creditCount',
          name: 'Támogatott hitel'
        },
        {
          storeName: 'applicationCount',
          name: 'Támogatás'
        },
        {
          storeName: 'guaranteeCount',
          name: 'Hitelgarancia'
        },
        {
          storeName: 'capitalProductCount',
          name: 'Tőkeprogram'
        }
      ]
    }
  },
  async created() {
    const { soleProprietorshipId } = queryString.parse(location.search)

    this.$gtag.event('sole_proprietorship_offers_public', {
      event_category: 'user_interaction',
      soleProprietorshipId: soleProprietorshipId
    })

    if (!soleProprietorshipId) {
      this.$router.push('/')
    }
    this.selectedSoleProprietorshipId = soleProprietorshipId
    const getSoleProprietorshipQueryParams = { value: soleProprietorshipId }
    try {
      await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
      await this.$store.dispatch('getCompetitionCountsSoleProprietorship', {
        soleProprietorshipId: soleProprietorshipId
      })
      this.showAnimatedElements = true
    } catch (err) {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters([
      'selectedSoleProprietorship',
      'applicationCount',
      'creditCount',
      'guaranteeCount',
      'capitalProductCount',
      'totalCount',
      'companyUnderTermination',
      'isLoading'
    ])
  },
  methods: {
    nextPage() {
      this.$router.push({ path: 'register', query: { soleProprietorshipId: this.$route.query.soleProprietorshipId } })
    }
  }
}
</script>

<style scoped>
.offer-badge-holder {
  height: 85px;
}

.circle-box {
  box-shadow: 0px 0px 0px 15px var(--color-lightgreen);
  font-size: 80px;
  width: 200px;
  height: 200px;
  font-weight: bold;
  margin-top: 4.5rem;
  margin-bottom: 3rem;
}

.circle-mini-box {
  width: 50px;
  height: 50px;
  margin-top: -7px;
}

.offer-badge-svg {
  margin-right: 10px;
}

.offer-text {
  font-size: 24px;
}
</style>
